import { useAuth } from "@/providers/auth-provider";

/**
 * Returns true when the signed-in user has admin role. Role is propagated
 * via BetterAuth's `additionalFields` so the session cookie carries it.
 * Returns null while the session is still loading — useful for "don't render
 * either branch yet" gates in route guards.
 */
export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { user, isLoading } = useAuth();
  const role = user && typeof user === "object" ? (user as { role?: unknown }).role : undefined;
  return { isAdmin: role === "admin", isLoading };
}
